import { SWRConfig } from "swr";
import { SWRConfigContainerProps } from "typing";

const CustomSWRConfig = ({ children, fallback }: SWRConfigContainerProps) => {
  return <SWRConfig value={{ fallback }}>{children}</SWRConfig>;
};

export { CustomSWRConfig };
